
import { Component, Vue } from 'vue-property-decorator'
import { AppModule } from '@/store/modules/app'
import { UserModule } from '@/store/modules/user'
import Hamburger from '@/components/hamburger/index.vue'
import Breadcrumb from '@/components/breadcrumb/index.vue'
import Screenfull from '@/components/screenfull/index.vue'
import MonitorEntry from '@/views/monitor/components/monitor-entry.vue'

@Component({
    name: 'Navbar',
    components: {
        Hamburger,
        Breadcrumb,
        Screenfull,
        MonitorEntry
    }
})
export default class extends Vue {

    get sidebar() {
        return AppModule.sidebar
    }

    get device() {
        return AppModule.device.toString()
    }

    get name () {
        return UserModule.name
    }

    get avatar() {
        return UserModule.avatar
    }

    private toggleSideBar() {
        AppModule.toggleSideBar(false)
    }

    private goToProfile() {
        this.$router.push('/profile/index')
    }

    private handleCommand(command: string) {
        if (command === 'profile') {
            this.goToProfile()
        } else if (command === 'logout') {
            this.logout()
        }
    }

    private async logout() {
        await UserModule.logOut()
        this.$router.push(`/login?redirect=${this.$route.fullPath}`)
    }
}
